<template>
    <div>
        <div class="panel-toolbar pr-3 pb-2 align-self-end">
            <button class="btn btn-md btn-block btn-outline-info waves-effect waves-themed" v-on:click="add_prod()">
                <span class="fal  fa-eject mr-1"></span>
                {{__t('ADD_SHIPPING')}}
            </button>
        </div>

        <div class="border bg-light rounded-top" v-if="shippings.length > 0">
            <div id="js_list_accordion" class="accordion accordion-hover accordion-clean js-list-filter">
                <div class="card border-top-left-radius-0 border-top-right-radius-0" v-for="shipping in shippings">
                    <div class="card-header" v-on:click="edit_type(shipping)">
                        <a href="javascript:void(0);" class="card-title collapsed pt-2 pb-2" >
                            <i class="fa fa-fog pr-4"></i>

                            <div>
                                <div>
                                    {{shipping.title}}
                                </div>
                                <div class="small badge border border-success">
                                    POS_ID: {{shipping.uniq_id}}
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "organization_shippings",

    props : {
        org : {
            type : Object
        }
    },
    data() {
        return {
            shippings: [],
        }
    },

    created() {
        EventBus.$on('reload_org_type',this.check_load);
        this.load_shippings();
    },

    methods : {

        check_load(type) {
            if(type == 'shipping') {
                this.load_shippings();
            }
        },

        edit_type(item) {
            EventBus.$emit('make_type_org','shipping',item,parseInt(this.org.id));
        },

        add_prod() {
            EventBus.$emit('make_type_org','shipping',null,parseInt(this.org.id));
        },

        async load_shippings() {
            this.shippings = [];
            await api.get('/internal/v1/catalog/organizations/'+ parseInt(this.org.id) +'/shipping',{}).then(({data}) => {
                if (data.status === "operation_success") {
                    this.shippings = data.data;
                }
            }).catch(({response}) => {
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },
    }

}
</script>

<style scoped>

</style>
